import type { Car } from '../../../../../types'

export default function AccountInfo({ car }: { car: Car }) {
  if (!car) return null

  const { accountNo: account, registrationNumber, make, model, driverName } = car
  if (!account && !registrationNumber && !(make || model) && !driverName) return null

  return (
    <div className="flex flex-col gap-1 text-sm">
      {account && (
        <div>
          <span className="text-secondaryText">Konto:</span>
          <span className="ml-2">{account}</span>
        </div>
      )}
      {registrationNumber && (
        <div>
          <span className="text-secondaryText">Regnr:</span>
          <span className="ml-2">{registrationNumber || ''}</span>
        </div>
      )}
      {(make || model) && (
        <div>
          <span className="text-secondaryText">Bil:</span>
          <span className="ml-2">
            {make} {model}
          </span>
        </div>
      )}
      {driverName && (
        <div>
          <span className="text-secondaryText">Sjåfør:</span>
          <span className="ml-2">{driverName || ''}</span>
        </div>
      )}
    </div>
  )
}
